// Where the pot chip pile sits (just under the centered community cards); used as
// the flight target for collected bets and the source when the pot is awarded.
// This one is a fixed point at the table center, so it doesn't depend on table size.
//
// Seat / bet-chip / dealer anchors and the per-seat card & profile style helpers
// used to live here as hardcoded percentages. They now live in useTableGeometry.js,
// which computes them from the table's MEASURED size so they stay glued to the felt
// rings at any window shape. The old static tables are kept there as FALLBACK_* for
// the first paint.
export const POT_POSITION = { bottom: '38%', left: '50%' };
